import { PropsWithChildren, ReactNode } from 'react';

import { Box, Popover } from '@mui/material';

import { useDatePickerContext } from './useDatePickerContext';
import { SxProps } from '../../../types';
import { mergeSx } from '../../../utils';
import { tokens } from '../../../theme/generated/tokens';

type DatePickerPopperProps = {
  aside?: ReactNode;
  popoverSx?: SxProps;
  testId?: string;
  footer?: ReactNode;
};

export const DatePickerPopper = ({
  children,
  aside,
  popoverSx,
  footer,
  testId = 'date-picker',
}: PropsWithChildren<DatePickerPopperProps>) => {
  const ctx = useDatePickerContext();

  const isOpen = Boolean(ctx.popoverAnchor);

  return (
    <Popover
      sx={mergeSx({ top: 4 }, popoverSx)}
      slotProps={{
        paper: {
          sx: {
            backgroundColor: tokens.theme.bg.structural.surface,
            boxShadow: tokens.theme.shadows.elevation.medium,
            borderRadius: tokens.theme.radius.sm,
          },
        },
      }}
      open={isOpen}
      anchorEl={ctx.popoverAnchor}
      onClose={ctx.handleClose}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          ctx.handleApply();
        }
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      data-testid={`${testId}-popover`}
    >
      <Box display="flex" width="fit-content">
        {aside}

        <div>{children}</div>
      </Box>
      {footer}
    </Popover>
  );
};
